import { Box, Typography } from '@mui/material';

interface DetalleCorreccionProps {
    /** "Mail", "CIIU del sector (Planta Norte)"… (ver `agruparCorrecciones`). */
    detalles: string[];
    comoResolver?: string;
}

/**
 * Qué hay que cambiar en una corrección cuyo mensaje es genérico ("Falta
 * completar un dato obligatorio del establecimiento"): el dato que falta, en
 * qué registro, y cómo resolverlo. Pedido del 06/10/2026: los errores de
 * establecimiento no decían qué arreglar.
 */
const DetalleCorreccion = ({ detalles, comoResolver }: DetalleCorreccionProps) => {
    if (!detalles.length && !comoResolver) return null;
    return (
        <Box
            data-testid="detalle-correccion"
            sx={{
                mt: 0.5,
                display: 'grid',
                gap: 0.25,
                // Dentro de AlertDialog una regla global centra todo div:nth-child(2).
                '& > div': { textAlign: 'left !important', justifyContent: 'flex-start !important' }
            }}
        >
            {detalles.length > 0 && (
                <Typography component="div" variant="body2" sx={{ fontSize: 13, color: '#1E272E' }}>
                    <Box component="span" sx={{ fontWeight: 700 }}>
                        Falta:{' '}
                    </Box>
                    {detalles.join(' · ')}
                </Typography>
            )}
            {comoResolver && (
                <Typography
                    component="div"
                    variant="body2"
                    sx={{ fontSize: 12.5, color: '#5F6B70' }}
                >
                    {comoResolver}
                </Typography>
            )}
        </Box>
    );
};

export default DetalleCorreccion;
